// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__D6rWU","signatureButtonsRight":"ModalSign_signatureButtonsRight__2nAJS"};